<template>
  <div class="flex flex-col px-2 py-4 bg-white border-b border-t border-solid border-grey-lightest mb-3" v-if="consultFollowupReminders.length > 0 || testFollowupReminders.length > 0">
    <div class="flex flex-col bg-white mt-2 mx-2 flex-no-shrink flex-no-grow">
      <label class="text-sm font-semibold text-grey-dark mb-2 mr-1 tracking-wide" style="text-transform: uppercase">Scheduled follow ups</label>
    </div>
    <div v-if="consultFollowupReminders.length > 0" >
      <div v-for="(r, i) in consultFollowupReminders" :key="i" class="flex flex-col border border-solid border-grey-lightest rounded-sm mx-2 p-4 my-2">
        <div v-if="r.followup_type === 'consultation'">
          <div class="flex flex-row">
            <div class="flex flex-row items-center">
              <img class="w-6 h-6 cursor-pointer" src="../../../assets/tick_green.svg">
              <div class="text-green ml-4 font-semibold flex text-sm">
                Consultation <p class="ml-1 text-grey-darkest font-semibold">on {{r.scheduled_time | formatDateWithoutTime}}</p>
              </div>
            </div>
            <div class="flex ml-auto text-sm">
              Set on: <p class="ml-1 text-grey-darkest font-semibold">{{r.created_at | formatDateWithoutTime}}</p>
            </div>             
          </div>
          <div class="flex mx-10 mt-4">
            <p class="text-xs text-grey-dark">Reminder will be sent to {{customer.name}} 48 hours before the event to consult back to you</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="testFollowupReminders.length > 0" class="flex flex-col border border-solid border-grey-lightest rounded-sm mx-2 p-4 my-2">
      <div class="flex flex-row">
        <div class="flex flex-row items-center">
          <img class="w-6 h-6 cursor-pointer" src="../../../assets/tick_green.svg">
          <div class="text-green ml-4 font-semibold flex text-sm">
            Lab Test follow ups
          </div>
        </div>
        <div class="flex ml-auto text-sm">
          Set on: <p class="ml-1 text-grey-darkest font-semibold">{{testFollowupReminders[0].created_at | formatDateWithoutTime}}</p>
        </div>             
      </div>
      <div v-for="(l, i) in testFollowupReminders" :key="i" class="flex flex-row w-auto ml-10 mt-2 text-sm bg-grey-extralight h-8 text-dark py-2 px-3" style="border-radius: 25px" >
        {{l.package_name}}&nbsp<p class="flex text-grey-darkest font-semibold">on {{l.scheduled_time | formatDateWithoutTime}}</p>
      </div>
      <div class="flex mx-10 mt-4">
        <p class="text-xs text-grey-dark">Reminder will be sent to {{customer.name}} 48 hours before the event to consult back to you</p>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  components: {
  },
  props: [],
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile'
    }),
    testFollowupReminders: function () {
      let that = this
      if (that.customer && that.customer.consultation && that.customer.consultation.followupReminders) {
        let followupReminders = that.customer.consultation.followupReminders.filter(function (ele) {
          return (ele.followup_type === 'lab_test')
        })
        followupReminders.map(function (r) {
          let t = that.customer.consultation.recommendedTests.find(function (ele) {
            return (ele.test_id === r.recommended_test_id)
          })
          if (t) {
            r.package_name = t.package_name
          } else {
            r.package_name = 'NA'
          }
          return r
        })
        return followupReminders
      }
      return []
    },
    consultFollowupReminders: function () {
      if (this.customer && this.customer.consultation && this.customer.consultation.followupReminders) {
        return this.customer.consultation.followupReminders.filter(function (ele) {
          return (ele.followup_type === 'consultation')
        })
      }
      return []
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Customer/FollowUp/Scheduled.vue